export default __webpack_public_path__ + "static/210602_夏日活動強更預告_sc-94e5ddf0726475374b61cbd6a77c1993.png";